if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

function openModalGuiaMedidas() {
  var modal = document.getElementById("popup_guia_de_medidas");
  modal.style.display = "block";
}

function closeModalGuiaMedidas() {
  var modal = document.getElementById("popup_guia_de_medidas");
  modal.style.display = "none";
}

// Fechar modal clicando fora do conteúdo
window.onclick = function(event) {
  var modal = document.getElementById("popup_guia_de_medidas");
  if (event.target == modal) {
    modal.style.display = "none";
  }
}

function openModalFrete() {
  var modal = document.getElementById("popup_frete");
  modal.style.display = "block";
}

function closeModalFrete() {
  var modal = document.getElementById("popup_frete");
  modal.style.display = "none";
}
